import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "pgsql",
  extensions: [],
  aliases: ["PostgreSQL", "postgres", "pg", "postgre"],
  loader: () => import('./pgsql.js')
});
